import { IMPORT_SIZE_BUCKETS } from './import-size-analytics.js';
import type { PropRule } from './analytics-types.js';

const IMAGE_IMPORT_FAILURES = ['read_only', 'globe_unavailable', 'pro_required', 'image_limit', 'file_too_large', 'save_not_completed', 'save_failed', 'prepare_failed', 'decode_failed', 'upload_forbidden', 'http_error', 'network_error', 'invalid_response', 'placement_failed', 'map_changed', 'unexpected'] as const;
export type ImageImportFailure = typeof IMAGE_IMPORT_FAILURES[number];
export type ImageImportSource = 'paste' | 'drop';

export const IMAGE_IMPORT_PROPS = {
  source: new Set(['paste', 'drop']),
  file_type: new Set(['png', 'jpeg', 'gif', 'webp', 'avif', 'heif', 'tiff', 'other']),
  file_size_bucket: IMPORT_SIZE_BUCKETS,
};
export const IMAGE_IMPORT_FAILURE_VALUES = new Set<string>(IMAGE_IMPORT_FAILURES);

export function imageImportEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  const image = { ...common, ...IMAGE_IMPORT_PROPS };
  const save = { ...image, stage: new Set(['before_upload', 'after_upload']) };
  return {
    image_import_attempted: image,
    image_import_succeeded: image,
    image_import_failed: { ...image, reason: IMAGE_IMPORT_FAILURE_VALUES },
    image_import_canceled: save,
    image_import_dialog_failed: save,
    image_import_save_failed: save,
  };
}

export function imageImportFileType(file: Pick<File, 'type' | 'name'>): string {
  const type = file.type.toLowerCase().replace(/^image\//u, '');
  const extension = file.name.split('.').at(-1)?.toLowerCase() ?? '';
  for (const candidate of [type, extension]) {
    if (/^jpe?g$/u.test(candidate)) return 'jpeg';
    if (/^hei[cf](?:-sequence)?$/u.test(candidate)) return 'heif';
    if (/^tiff?$/u.test(candidate)) return 'tiff';
    if (['png', 'gif', 'webp', 'avif'].includes(candidate)) return candidate;
  }
  return 'other';
}
